import PaidStatusFilter from "../components/PaidStatusFilter";

export default [PaidStatusFilter]